import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardSet from '@/components/CardSet.vue';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const classesModule = namespace('classes');
let HandbookClasses = class HandbookClasses extends Vue {
    created() {
        this.fetchClasses();
    }
    get classesWithLinks() {
        return this.classes.map(charClass => ({
            ...charClass,
            to: `classes/${charClass.name}`
        }));
    }
    showSaves(saves) {
        return saves.join(' and ');
    }
};
__decorate([
    classesModule.State
], HandbookClasses.prototype, "classes", void 0);
__decorate([
    classesModule.Action
], HandbookClasses.prototype, "fetchClasses", void 0);
HandbookClasses = __decorate([
    Component({
        components: {
            Loading,
            BackButton,
            CardSet
        }
    })
], HandbookClasses);
export default HandbookClasses;
